let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("446nl")).then(() => parcelRequire('5lFG8'));